module.exports = __webpack_public_path__ + "static/media/VirtualTerminal.e2199884.svg";